import { validate } from "it-validator"

export default {
  data() {
    return {
      errors: {},
      states: {}
    }
  },

  methods: {
    async valid(input = null) {
      const params = { [input]: this.form[input] }
      const rules = () => ({ [input]: this.rules[input] })
      const { err } = await validate(params, rules)
      this.states[input] = err ? "error" : "success"
      this.$set(this.errors, input, err ? err[input] : null)
    },
    async validateAll() {
      const { err, values } = await validate(this.form, () => this.rules)
      if (err) {
        this.errors = err
        Object.keys(this.errors).forEach(item => {
          this.states[item] = "error"
        })
      } else {
        this.errors = {}
        Object.keys(this.form).forEach(item => {
          this.states[item] = "success"
        })
      }
      return { err, values }
    }
  }
}
